import { withStyles } from '@material-ui/core';
import BillingToolBar from './BillingToolBar';
import styles from './styles';

export default withStyles(styles)(BillingToolBar);
